export class NotificationModel {
    public title: string;
    public subtitle: string;
    public content: string;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.title = json.title;
            this.subtitle = json.subtitle;
            this.content = json.content;
        }
    }
}

export class NotificationEvent {
    public userId: string;
    public messages: any;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.userId = json.userId;
            this.messages = json.messages;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/shared/notifications/notification.model.ts